import $ from 'jquery';

const D = document;
const $D = $(D);

$.addToClipboard = async value => {
  try {
    if (navigator && navigator.clipboard) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    /* noop */
  }

  return false;
};

$D.on('click', '[data-copyable]', async evt => {
  evt.preventDefault();
  evt.stopImmediatePropagation();

  const $obj = $(evt.target);
  const data = $obj.data();
  const color = data.color || 'primary';
  const result = await $.addToClipboard(data.content || $obj.text());

  if (result) {
    if (!data['bs.tooltip']) {
      $obj
        .tooltip({
          boundary: 'window',
          trigger: 'manual',
          title: 'Copied!',
          delay: 300,
        })
        .on('inserted.bs.tooltip', () => {
          const $tip = $($obj.data('bs.tooltip').tip);
          $tip.addClass(`tooltip-${color}`);
        });
    }

    $obj.tooltip('show');
    setTimeout(() => $obj.tooltip('hide'), 1000);
  }
});
